import type { Order } from '~api/tos';

import { Link as RouterLink } from 'react-router-dom';

import { DropdownMenu, MoreButton } from '@ingrid/luterkort-react';

import { RoleGuard } from '~src/components/RoleGuard/RoleGuard';
import { useTranslation } from '~src/i18n/use-translation';
import { AppRoute } from '~src/main/routes';

interface Props {
  order: Order;
  listing?: boolean;
}

export function Menu({ listing, order }: Props) {
  const { t } = useTranslation();

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger>
        <MoreButton size={listing ? 'sm' : 'md'} />
      </DropdownMenu.Trigger>

      <DropdownMenu.Content>
        <RoleGuard roles={['transport:edit']} withTooltip>
          <DropdownMenu.Item asChild>
            <RouterLink to={`${order.id}/${AppRoute.SHIPMENTS_CREATE}`}>{t('common.createShipment')}</RouterLink>
          </DropdownMenu.Item>
        </RoleGuard>
        <DropdownMenu.Item asChild>
          <RouterLink to={order.id!}>{t('common.showDetails')}</RouterLink>
        </DropdownMenu.Item>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
}
